export default __webpack_public_path__ + "static/media/km.b58bf31e.jfif";